import React from 'react';
import classnames from 'classnames';

const Container = ({ type = 'table', children, tableClassName, gridClassName }) => {
	// Concat wrap className based on display type
	const wrapCls = classnames(
		'max-w-full',
		type === 'table' && 'overflow-x-auto sm:overflow-x-visible',
	);

	// Concat container className based on display type
	const cls = classnames(
		'text-sm text-neutral-700 dark:text-neutral-100',
		
		// Table type classes
		type === 'table' && 'table whitespace-nowrap',
		type === 'table' && tableClassName,

		// Grid type classes
		type === 'grid' && 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
		type === 'grid' && gridClassName
	);

	return (
		<div className={wrapCls}>
			<div className={cls}>
				{React.Children.map(children, child => (
					<>
						{React.cloneElement(child, { type })}
					</>
				))}
			</div>
		</div>
	);
};

const Header = ({ type, children }) => {
	// Concat container className based on display type
	const cls = classnames(
		// Table type classes
		type === 'table' && 'table-header-group'
	);

	// Do not display header row unless table type is enabled
	if (type === 'grid') return null;

	return (
		<div className={cls}>
			<div className="table-row">
				{children}
			</div>

			{/* Spacer between heading and body */}
			<div className="table-row">
				<div className="table-cell h-2"></div>
			</div>
		</div>
	);
};

const HeaderItem = ({ children, tableClassName }) => {
	// Concat container className based on display type
	const cls = classnames(
		'table-cell h-10 px-2 first:pl-4 last:pr-4 leading-10 text-neutral-500 bg-neutral-100 dark:text-neutral-400 dark:bg-neutral-800 first:rounded-l-lg last:rounded-r-lg',
		tableClassName
	);

	return (
		<div className={cls}>
			{children}
		</div>
	);
};

const Element = ({ type, children, tableClassName, gridClassName }) => {
	// Concat container className based on display type
	const cls = classnames(
		// Table type classes
		type === 'table' && 'table-row group',
		type === 'table' && tableClassName,

		// Grid type classes
		type === 'grid' && 'flex flex-wrap py-3 px-4 hover:bg-neutral-100 hover:dark:bg-neutral-800 rounded-lg transition-colors',
		type === 'grid' && gridClassName
	);
	
	return (
		<div className={cls}>
			{React.Children.map(children, child => (
				<>
					{React.cloneElement(child, { type })}
				</>
			))}
		</div>
	);
};

const ItemGroup = ({ type, children, gridClassName }) => {
	if (type === 'table') {
		return (
			<>
				{React.Children.map(children, child => (
					<>
						{React.cloneElement(child, { type })}
					</>
				))}
			</>
		);
	}

	if (type === 'grid') {
		return (
			<div className={gridClassName}>
				{React.Children.map(children, child => (
					<>
						{React.cloneElement(child, { type })}
					</>
				))}
			</div>
		);
	}
};

const Item = ({ type, children, tableClassName, gridClassName }) => {
	const cls = classnames(
		// Table type classes
		type === 'table' && 'table-cell align-middle h-10 px-2 first:pl-4 last:pr-4',
		type === 'table' && 'group-hover:bg-neutral-100 dark:group-hover:bg-neutral-800 transition-colors',
		type === 'table' && 'first:rounded-l-lg last:rounded-r-lg',
		type === 'table' && tableClassName,

		// Grid type classes
		type === 'grid' && '',
		type === 'grid' && gridClassName
	);

	return (
		<div className={cls}>
			{children}
		</div>
	);
};

export {
	Container,
	Header,
	HeaderItem,
	Element,
	ItemGroup,
	Item
};